import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=26624aa8&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26624aa8')) {
      api.createRecord('26624aa8', component.options)
    } else {
      api.reload('26624aa8', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=26624aa8&", function () {
      api.rerender('26624aa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KbbYM7UFpNkf/JS/ImageCarousel.vue"
export default component.exports